<template>
  <div>
    <treeselect
        v-model="model"
        :name="name"
        :options="options"
        :placeholder="placeholder"
        noResultsText="Nichts gefunden"
    ></treeselect>
  </div>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'single-select',
  components: {treeselect},

  props: {
    options: Array,
    name: String,
    value: [String, Number],
    placeholder: {
      type: String,
      default: 'Bitte wählen...'
    }
  },

  data() {
    return {
      model: null,
    }
  },

  mounted() {
    // prefill old values
    this.model = this.value ? this.value : null
  },

  watch: {
    value(newValue) {
      this.model = newValue;
    },
    model(newValue) {
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    }
  }
}
</script>

<style scoped>
/* make the placeholder black so it matches other selects */
.vue-treeselect__placeholder {
  color: black;
}

.vue-treeselect--focused .vue-treeselect__placeholder {
  color: #BDBDBD;
}
</style>
